module.exports = __webpack_public_path__ + "img/dashboard.a441d89b.svg";